export interface Config {
    env: string
    storageBaseUrl: string
    giphyApiKey: string
    giphyEnabled: boolean
}

if (!("config" in window)) {
    throw new Error('No config in window')
}

export const config: Config = {
    // @ts-ignore
    ...(window.config as Config),
}

export const useConfig: () => Config = () => {
    return config
}
